import React, { useContext } from 'react';
import { observer } from 'mobx-react';
import { makeStyles } from '@material-ui/core/styles';

import { useStore } from 'core/store';
import { AuthContext } from 'core/components/auth';
import FormList from 'core/components/form-list';
import { useDisabledState } from 'common/disabled-context';
import AddApplicant from 'common/components/people/add-form';
import { Locations } from 'common/components/farm/locations';
import { PolicyWideEndorsements } from 'common/components/farm/policy-wide-endorsements';
import { AddMortgage, MortgageItem } from 'common/components/mortgage-details';
import Applicant from '../applicant/applicant';

const useStyles = makeStyles((theme) => ({
  innerContainer: {
    padding: theme.spacing(8),
    backgroundColor: theme.colors.card_background_primary_editable,
    borderRadius: theme.sizes.roundCorners
  }
}));

const FarmPolicy = () => {
  const session = useContext(AuthContext);
  const classes = useStyles();
  const {
    account: {
      policies: { policy: policyStore }
    }
  } = useStore();

  const allowLicensedActions = policyStore.getAllowLicensedActions(session);
  const { disabled } = useDisabledState();

  return (
    <>
      <FormList
        disabled={disabled || !allowLicensedActions}
        id="people"
        title="People"
        item={Applicant}
        addForm={AddApplicant}
        addLabel="Add People"
        fromPolicy
      />
      <Locations />
      <PolicyWideEndorsements />
      <FormList
        classes={classes}
        id="farm.mortgageDetails"
        item={MortgageItem}
        addForm={AddMortgage}
        title="Mortgage lender information"
        singular="Mortgage"
        plural="Mortgages"
        disabled={disabled}
      />
    </>
  );
};

export default observer(FarmPolicy);
